import type { AiAppCenterModule } from '../types'

/**
 * 物业管理系统（智慧社区）
 * 后端 system_module.name=property；独立窗 key/path 为 /property
 * 菜单挂在 /ai-Application-center/property 下，独立窗自动加前缀
 */
export const propertyModule: AiAppCenterModule = {
  key: 'property',
  label: '物业管理',
  desc: '报修工单 / 投诉处理 / 物业运营管理',
  path: '/property',
  standalonePath: '/ai-Application-center/property/cockpit/index',
  homePath: '/property/cockpit/index',
  // 侧栏菜单挂在后端 /ai-Application-center/property 下（moduleRootPathCandidates 会同时匹配带/不带前缀）
  menuPaths: ['/property'],
  icon: 'ep:office-building',
  color: '#0ea5e9',
  aliases: ['物业管理', '智慧家园', '掌上物业', '物业系统']
}
